/**
 * calcBM — Brickmould trim package cut list calculations
 *
 * All formulas verified against BRICKMOULD TEMPLATE sheet in TWP_Cutlist_For_DNA.xltm.
 * Cell references noted inline for future auditing.
 *
 * COMPLETE REWRITE of previous version which incorrectly treated BM as a
 * glazed picture window (with glass, frame extrusions, and glazbead).
 *
 * BM is a TRIM PACKAGE — no glass, no sash, no frame extrusions, no glazbead.
 * It contains:
 *   - 5938 standard brickmould (wraps the exterior of the window)
 *   - 8367 nail-fin brickmould (for nail-fin / with-fin applications)
 *   - PVC White Jamb Extensions (interior wood replacement)
 *
 * FIXES (entire file rewritten):
 *  1. Removed: glass (overallW-4.625 etc.)    — NO GLASS in BM
 *  2. Removed: 5154 frame widths/heights       — NO FRAME EXTRUSIONS in BM
 *  3. Removed: 5107 glazbead widths/heights    — NO GLAZBEAD in BM
 *  4. Added:   5938 Brickmould W = overallW+8.0625  (D22=B18+8.0625)
 *  5. Added:   5938 Brickmould H = height+8.0625    (D23=C18+8.0625)
 *  6. Added:   8367 NF BM W = overallW+5.25         (D26=B18+5.25)  part=8367-color
 *  7. Added:   8367 NF BM H = height+5.25           (D27=C18+5.25)  part=8367-color
 *  8. Added:   Jamb Ext Width  = overallW-1.375      (D31=B18-1.375) part=PVC
 *  9. Added:   Jamb Ext Height = height+0.125        (D32=C18+0.125) part=PVC
 */
export function calcBM(window) {
  const {
    overallW, height, color,
    qty, label
  } = window;

  const totalQty = qty;

  // ── 5938 Standard Brickmould ──────────────────────────────────────────────
  // Wraps outside of window unit — 2 horizontal (top+bottom), 2 vertical (L+R)
  // D22 = B18 + 8.0625 = overallW + 8.0625
  // D23 = C18 + 8.0625 = height   + 8.0625
  const bm5938W = overallW + 8.0625;   // D22
  const bm5938H = height   + 8.0625;   // D23
  // Part: 5938 (no color suffix shown in Excel)

  // ── 8367 Nail-Fin Brickmould ──────────────────────────────────────────────
  // Used for nail-fin / with-fin window applications
  // D26 = B18 + 5.25 = overallW + 5.25
  // D27 = C18 + 5.25 = height   + 5.25
  const bm8367W = overallW + 5.25;     // D26
  const bm8367H = height   + 5.25;     // D27
  const bm8367Part = `8367-${color}`;

  // ── White Jamb Extensions ─────────────────────────────────────────────────
  // PVC interior jamb replacement pieces
  // Width:  D31 = B18 - 1.375 = overallW - 1.375   (horizontal top/bottom)
  // Height: D32 = C18 + 0.125 = height   + 0.125   (vertical sides)
  const jambExtW = overallW - 1.375;   // D31
  const jambExtH = height   + 0.125;   // D32

  // ── Reference sizes (footer display) ──────────────────────────────────────
  // Large BM Size: overallW+8.0625 × height+8.0625  (same as 5938)
  // NF BM Size:    overallW+5.25   × height+5.25    (same as 8367)

  return {
    label,
    type:       'BM',
    color,
    overallW,
    width:      overallW,
    height,
    config:     'Single',
    qty,
    totalQty,

    // BM has no glass, sash, frame extrusions, or glazbead
    glass:          [],
    frame:          [],
    sash:           [],
    glazbead:       [],
    reinforcement:  [],
    flexScreen:     null,
    stdScreen:      null,

    // ── 5938 Standard Brickmould ────────────────────────────────────────────
    brickmould5938: [
      { label: '5938 Brickmould Widths',  qty: totalQty * 2, length: bm5938W, part: '5938' },  // D22, C22=B15*2
      { label: '5938 Brickmould Heights', qty: totalQty * 2, length: bm5938H, part: '5938' },  // D23, C23=B15*2
    ],

    // ── 8367 Nail-Fin Brickmould ────────────────────────────────────────────
    brickmould8367: [
      { label: '8367 Brickmould Widths',  qty: totalQty * 2, length: bm8367W, part: bm8367Part },  // D26
      { label: '8367 Brickmould Heights', qty: totalQty * 2, length: bm8367H, part: bm8367Part },  // D27
    ],

    // ── Jamb Extensions ─────────────────────────────────────────────────────
    jambExtensions: [
      { label: 'Jamb Ext Width',  qty: totalQty,     length: jambExtW, part: 'PVC' },  // D31, C31=B15*1
      { label: 'Jamb Ext Height', qty: totalQty * 2, length: jambExtH, part: 'PVC' },  // D32, C32=B15*2
    ],

    // ── Summary / reference sizes ────────────────────────────────────────────
    summary: {
      largeBMW:  bm5938W,    // Large BM Size W = overallW + 8.0625
      largeBMH:  bm5938H,    // Large BM Size H = height   + 8.0625
      nfBMW:     bm8367W,    // NF BM Size W    = overallW + 5.25
      nfBMH:     bm8367H,    // NF BM Size H    = height   + 5.25
      jambExtW,
      jambExtH,
    },
  };
}